import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent {
  slideOption: OwlOptions = {
    loop: true,
    autoplay: false,
    mouseDrag: true,
    touchDrag: true,
    dots: false,
    nav: false,
    autoWidth:true,
    center:true,
    margin:10,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 4
      },
      940: {
        items: 5
      }
     
    },
  };
  items= [
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
    {
      img:'https://ath2.unileverservices.com/wp-content/uploads/sites/3/2017/09/professional-mens-hairstyles-combed-min-1024x683.jpg',
      name: "Arcu suscipit",
      desi: "Arcu suscipit"      
    },
  ]
}
